import RoundWidget from './mini/mini.model';
import WideWidget from './wide/wide.model';
import { WideWidgetStyle } from './wide/wide-widget-style';
import { DentoloEventName, WIDGET_EXISTENCE_ERROR } from '../../constants';
import { Dentolo } from '../../dentolo';
import EventEmitter from '../event-emitter.model';

type WidgetMode = 'wide' | 'mini';

export default class Widget implements Dentolo.IWidget {
	private miniWidget:RoundWidget;
	private wideWidget:WideWidget;
	private wideWidgetStyle:WideWidgetStyle;
	private showMiniatureOnHide:boolean;
	private zIndex:number;
	private destroyed:boolean = false;


	public mode:WidgetMode;
	public element:HTMLDivElement | undefined;
	public hideOnOpenQuiz:boolean = false;

	constructor(options:Dentolo.WidgetOptions, eventEmitter: EventEmitter<DentoloEventName>) {
		this.hideOnOpenQuiz = options.hideOnOpenQuiz || this.hideOnOpenQuiz;
		this.showMiniatureOnHide = options.showMiniatureOnHide == undefined ? true : options.showMiniatureOnHide;
		this.mode = options.mode || 'wide';
		this.wideWidgetStyle = options.wideWidgetStyle || 'default';
		this.zIndex = options.zIndex || 10000;
		this.miniWidget = new RoundWidget(this.mode == 'mini' ? 'active' : 'hidden', this.zIndex, options.miniWidgetPosition, options.miniWidgetColor);
		this.wideWidget = new WideWidget(this.wideWidgetStyle, this.zIndex, options.hideOnScrollingToBottom, options.wideButtonOnMobiles, options.wideWidgetOffer, options.wideWidgetButtonText, options.wideWidgetBackground, options.wideWidgetButtonShadow);
		this.wideWidget.onHide(() => {
			this.hide();
			eventEmitter.emit(DentoloEventName.CLOSE_FIX_BLOCK, {});
		});
	}
	
	public isDestroyed():boolean {
		return this.destroyed;
	}

	public getCurrentMode():WidgetMode | null {
		if (this.wideWidget.isActive()) return "wide";
		if (this.miniWidget.isActive()) return "mini";
		return null;
	}

	public show():void {
		switch (this.mode) {
			case 'mini': {
				this.miniWidget.show();
				break;
			}

			case 'wide': {
				this.wideWidget.show();
				if (this.showMiniatureOnHide) this.miniWidget.render(false);
				break;
			}
		}
	}

	public hide():void {
		switch (this.mode) {
			case 'mini': {
				this.miniWidget.hide();
				break;
			}

			case 'wide': {
				console.log("hide widget!");
				if (!this.wideWidget.isActive()) return;
				this.wideWidget.hide();
				if (this.showMiniatureOnHide) this.miniWidget.render(true);
				break;
			}
		}
	}

	public render():void {
		if (this.destroyed) return;
		this.miniWidget.render(this.mode == 'mini');
		this.wideWidget.render(this.mode == 'wide');
	}

	public onClick(callback:(event:MouseEvent)=>void):void {
		this.wideWidget.onClick(callback);
		this.miniWidget.onClick(callback);
	}

	public switchTo(mode:WidgetMode):void {
		if (this.destroyed) throw new Error(WIDGET_EXISTENCE_ERROR);
		this.mode = mode;
		this.render();
	}

	public destroy():void {
		this.destroyed = true;
		this.wideWidget.hide();
		this.miniWidget.hide();
		this.wideWidget.destructor();
		this.miniWidget.destructor();
		setTimeout(() => {
			try {
				document.body.removeChild(this.wideWidget.element);
				document.body.removeChild(this.miniWidget.element);
			} catch(e) { return }
		}, 500);
	}
}